import { render } from "./customsetting.vue?vue&type=template&id=24db4ac4"
import script from "./customsetting.vue?vue&type=script&lang=js"
export * from "./customsetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__